import { Button, DataTable } from '@skylabs-digital/backoffice-kit';
import type { ColumnDef } from '@skylabs-digital/tables-react';
import { useMemo } from 'react';
import { formatDuration } from '../../lib/format';
import type { ProcessingAppCounts } from '../../schemas/processing.schema';

export function ProcessingByAppTable({
  rows,
  onSelectApp,
}: {
  rows: ProcessingAppCounts[];
  onSelectApp: (appId: string) => void;
}) {
  const columns = useMemo<ColumnDef<ProcessingAppCounts>[]>(
    () => [
      {
        accessorKey: 'appName',
        header: 'App',
        cell: ({ row }) => (
          <Button
            variant="link"
            className="h-auto p-0"
            onClick={() => onSelectApp(row.original.appId)}
          >
            {row.original.appName}
          </Button>
        ),
      },
      { accessorKey: 'queued', header: 'Queued' },
      { accessorKey: 'completed', header: 'Completed' },
      { accessorKey: 'failed', header: 'Failed' },
      {
        id: 'wait',
        header: 'Avg wait',
        cell: ({ row }) => formatDuration(row.original.avgWaitSeconds),
      },
      {
        id: 'work',
        header: 'Avg work',
        cell: ({ row }) => formatDuration(row.original.avgWorkSeconds),
      },
    ],
    [onSelectApp],
  );
  return (
    <DataTable
      columns={columns}
      data={rows}
      hidePagination
      aria-label="Processing by app"
      empty={
        <p className="py-6 text-center text-sm text-muted-foreground">
          No app processed anything in this window
        </p>
      }
    />
  );
}
